export default "assets/images/icons/download-3fc1e93e.svg";